export async function getIndustries(){
    let data = []
      const axios = (await import("axios")).default;
      await axios.get('https://aitsmena.com/api/v1/industries', {
        headers: {
          'Cache-Control': 'max-age=3600', // Cache for 1 hour
        },
      })
      .then(res => {
        console.log("res", res)
        data = res.data;
      })
      .catch((error) => {
        console.log(error)
        data=[]
      })
    return data;
}

// Resources APIS
export async function getBlogs(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/blog-posts', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getSuccessStories(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/success-stories', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getWhitepapers(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/whitepapers', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getPressReleases(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/press-releases', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getIndustryInsights(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/industry-insights', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}

export async function getWebinars() {
  try {
    const axios = (await import("axios")).default;
    const response = await axios.get('https://aitsmena.com/api/v1/webinars', { // Changed from /api/v1/webinars to /api/webinars for consistency
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    });
    console.log("Webinars response:", response);
    return response.data; // Add type field for consistency
  } catch (error) {
    console.error("Error fetching webinars:", error);
    return [];
  }
}

export async function getWebinarBySlug(slug) {
  try {
    const axios = (await import("axios")).default;
    const response = await axios.get(`https://aitsmena.com/api/v1/webinars/${slug}`); // Changed from /api/v1/webinars to /api/webinars
    console.log("Webinar by slug response:", response);
    return { ...response.data, type: 'webinar' }; // Add type field for consistency
  } catch (error) {
    console.error(`Error fetching webinar with slug ${slug}:`, error);
    return null;
  }
}

// export async function getAllResources() {
//   try {
//     const allResources = await Promise.all([
//       getBlogs(),
//       getIndustryInsights(),
//       getSuccessStories(),
//       getPressReleases(),
//       getWebinars()
//     ]);

//     // Flatten the array of arrays into a single array
//     const flatResources = allResources.flat();
//     console.log("res", flatResources)

//     // Sort resources by 'published_at' date
//     return flatResources.sort((a, b) => new Date(b.published_at) - new Date(a.published_at));
//   } catch (error) {
//     console.error("Error fetching resources:", error);
//     return [];
//   }
// }

// Update to work with your existing functions

export async function getAllResources() {
  try {
    // Your current implementation already fetches all types of resources
    const allResources = await Promise.all([
      getBlogs(),
      getIndustryInsights(),
      getSuccessStories(),
      getPressReleases(),
      getWebinars()
    ]);

    // Flatten the array of arrays into a single array
    const flatResources = allResources.flat();
    
    // Ensure each resource has a type field for consistency
    const resourcesWithTypes = flatResources.map(resource => {
      // If it's from the webinars endpoint, mark it as webinar
      if (resource.youtube_id !== undefined) {
        return { ...resource, type: 'webinar' };
      }
      // Otherwise, it's a blog-type post
      return { ...resource, type: 'blog' };
    });

    console.log("All resources with types:", resourcesWithTypes);

    // Sort resources by 'published_at' date
    return resourcesWithTypes.sort((a, b) => new Date(b.published_at) - new Date(a.published_at));
  } catch (error) {
    console.error("Error fetching resources:", error);
    return [];
  }
}

// Get resources by slug
// export async function getBlogBySlug(slug) {
//   const blogPosts = await getBlogs();
//   return blogPosts.find(item => item.slug === slug);
// }

export async function getBlogBySlug(slug) {
  console.log(`Getting blog by slug: ${slug}`);
  try {
    // First approach: Try to get all blogs and find the one we need
    const blogPosts = await getBlogs();
    
    if (!blogPosts || !Array.isArray(blogPosts)) {
      throw new Error('Failed to fetch blogs or invalid response format');
    }
    
    const post = blogPosts.find(item => item.slug === slug);
    
    if (!post) {
      console.warn(`Blog post with slug "${slug}" not found`);
      // Return a fallback for SSG if in SSR mode
      if (import.meta.env.SSR) {
        return {
          id: 0,
          title: `Blog Post - ${slug}`,
          summary: 'Blog post summary placeholder',
          cover: null,
          industry: []
        };
      }
      throw new Error(`Blog with slug "${slug}" not found`);
    }
    
    console.log(`Successfully found blog: ${post.title}`);
    return post;
  } catch (error) {
    console.error(`Error in getBlogBySlug(${slug}):`, error);
    
    // Provide fallback data for SSR if fetch fails
    if (import.meta.env.SSR) {
      console.log('Using fallback blog data for SSR');
      return {
        id: 0,
        title: `Blog Post - ${slug}`,
        summary: 'Blog post summary placeholder',
        cover: null,
        industry: []
      };
    }
    throw error;
  }
}


// Careers APIS
export async function getJobs(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/jobs', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getInternships(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/internships', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}
export async function getGraduateProgramJobs(){
  let data = []
    const axios = (await import("axios")).default;
    await axios.get('https://aitsmena.com/api/v1/graduate-program-jobs', {
      headers: {
        'Cache-Control': 'max-age=3600', // Cache for 1 hour
      },
    })
    .then(res => {
      console.log("res", res)
      data = res.data;
    })
    .catch((error) => {
      console.log(error)
      data=[]
    })
  return data;
}